import { CheckBoxProps, CheckBoxWidget, Tooltip, TooltipPosition } from '@tableau/widgets';
import { BodyCell } from '@tableau/widgets-datagrid';
import React from 'react';

import { CheckboxState } from '~src/commonInfra/components/checkbox/CheckboxState';

import { Messages } from '../../codegen/Localize';
import { AddUsersToAdminProfileDataKeys, AddUsersToAdminProfileDialogTestIds } from './AddUsersToAdminProfileDialog';

interface CheckboxCellData {
  checkboxState: CheckboxState;
  onCheckboxChanged: () => void;
}

export class AddUsersToAdminProfileCellFormatter extends React.PureComponent<BodyCell.Props, object> {
  private renderCheckboxCell(): JSX.Element {
    const data = this.props.row.data[AddUsersToAdminProfileDataKeys.Select] as CheckboxCellData;
    const checkBoxProps: CheckBoxProps = {
      checked: data.checkboxState === CheckboxState.checked,
      handleChange: data.onCheckboxChanged,
      testId: AddUsersToAdminProfileDialogTestIds.gridRowCheckboxTestId + this.props.rowIdx,
    };
    const displayName = this.props.row.data[AddUsersToAdminProfileDataKeys.DisplayName] as string;
    return (
      <div>
        <CheckBoxWidget {...checkBoxProps} aria-label={Messages.selectDisplayName({ DISPLAY_NAME: displayName })} />
      </div>
    );
  }

  private renderDisplayNameCell(): JSX.Element {
    const displayName = this.props.row.data[AddUsersToAdminProfileDataKeys.DisplayName] as string;
    const username = this.props.row.data[AddUsersToAdminProfileDataKeys.Username] as string;
    return (
      <div>
        <Tooltip
          tooltipContent={`${displayName} (${username})`}
          position={TooltipPosition.Bottom}
        >
          <span data-tb-test-id={AddUsersToAdminProfileDialogTestIds.gridRowDisplayNameTestId + this.props.rowIdx}>
            {displayName}
          </span>
        </Tooltip>
      </div>
    );
  }

  private renderUsernameCell(): JSX.Element {
    const username = this.props.row.data[AddUsersToAdminProfileDataKeys.Username] as string;
    return <span>{username}</span>;
  }

  public render(): JSX.Element {
    switch (this.props.col.dataKey as AddUsersToAdminProfileDataKeys) {
      case AddUsersToAdminProfileDataKeys.Select:
        return this.renderCheckboxCell();
      case AddUsersToAdminProfileDataKeys.DisplayName:
        return this.renderDisplayNameCell();
      case AddUsersToAdminProfileDataKeys.Username:
        return this.renderUsernameCell();
      default:
        return <React.Fragment />;
    }
  }
}

export const AddUsersToAdminProfileCellFormatterFactory = React.createFactory(AddUsersToAdminProfileCellFormatter);
